(function handleStickyOnScrollUp() {
  let lastScrollTop = 0;
  const threshold = 100;
  const element = document.getElementById('main-collection-filters');
  if (!element) return;

  window.addEventListener('scroll', function () {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Set "top" for element
    const headerHeight = document.querySelector("#header")?.offsetHeight || 150;
    element.style.top = `${headerHeight}px`;

    if (currentScroll > threshold && currentScroll < lastScrollTop) {
      element.classList.add('sticky');
    } else {
      element.classList.remove('sticky');
    }

    lastScrollTop = Math.max(currentScroll, 0);
  });
})();